import { useMemo } from 'react';

import qs from 'qs';
import { useLocation } from 'react-router';

import { SEARCH_URL_KEYS } from '#src/app/pages/searchV2/shared/api';

type Result = ModelHookResult<{
	showLandingPage: boolean;
}>;

export function useLandingPage(): Result {
	const location = useLocation();

	const hasQuery = useMemo(() => {
		const query = qs.parse(location.search, { ignoreQueryPrefix: true });
		return Object.keys(query).some((key) => SEARCH_URL_KEYS.includes(key as (typeof SEARCH_URL_KEYS)[number]));
	}, [location]);

	return {
		data: {
			showLandingPage: !hasQuery,
		},
	};
}
